<app-hamburger-wrapper></app-hamburger-wrapper>
<section id="app-section" [ngClass]="namespaceClass">
  <app-alert-banner #alertBanner></app-alert-banner>
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-version></app-version>
</section>
